'use client'
import { walletConnectorEvents } from '@dynamic-labs/wallet-connector-core';
import { getEnabledProviders } from '../getEnabledProviders/getEnabledProviders.js';
import { getApiProviders } from '../getApiProviders/getApiProviders.js';
import { defaultWalletUiUtils } from '../../const.js';

const getWalletConnectorConstructorOptions = ({ appLogoUrl, appName, authMode, coinbaseWalletPreference, chainRpcProviders, deepLinkPreference, flowNetwork, mobileExperience, networkConfigurations, settings, walletConnectProjectId, walletUiUtils, walletBook, walletConnectPreferredChains, }) => {
    const eclipseNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.eclipse) || [];
    const evmNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.evm) || [];
    const solanaNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.solana) || [];
    const cosmosNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.cosmos) || [];
    const starknetNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.starknet) || [];
    const suiNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.sui) || [];
    const apiProviders = getApiProviders(getEnabledProviders(settings.providers));
    const opts = {
        apiProviders,
        appLogoUrl,
        appName,
        authMode,
        chainRpcProviders,
        coinbaseWalletPreference,
        cosmosNetworks: cosmosNetworkConfigs,
        deepLinkPreference,
        eclipseNetworks: eclipseNetworkConfigs,
        evmNetworks: evmNetworkConfigs,
        flowNetwork,
        mobileExperience,
        projectId: walletConnectProjectId,
        settings,
        solNetworks: solanaNetworkConfigs,
        starknetNetworks: starknetNetworkConfigs,
        suiNetworks: suiNetworkConfigs,
        walletBook,
        walletConnectPreferredChains,
        walletConnectorEventsEmitter: walletConnectorEvents,
        walletUiUtils: walletUiUtils || defaultWalletUiUtils,
    };
    return opts;
};

export { getWalletConnectorConstructorOptions };
